import appLogoUrl from '../../../design-docs/app-logo.png';

interface LogoProps {
  compact?: boolean;
}

export function Logo({ compact = false }: LogoProps) {
  if (compact) {
    return (
      <img
        className="brand-logo brand-logo--compact"
        src="/icons/icon-512.png"
        alt="LBC"
        width={512}
        height={512}
      />
    );
  }

  return (
    <span className="brand-logo brand-logo--lockup">
      <img src={appLogoUrl} alt="LBC – Lecker Bierchen Counter" width={1024} height={1024} />
    </span>
  );
}
